import React, { useCallback, useEffect, useState } from "react";
import { Grid, Box, Button } from '@mui/material';
import AxiosInstance from "../../../server/AxioInstance";
import SelectAutoComplete from "../../common/autoComplete/SelectAutoComplete";
import MultiSelectAutocomplete from "../../common/autoComplete/MultiSelectAutocomplete";
import { useSnackbar } from '../../../shared/context';


const LinkSectorSubSectorRegistre = ({ handleChangeComponent }) => {
    const [getOptionsSector, setOptionsSector] = useState([]);
    const [getOptionsSubSector, setOptionsSubSector] = useState([]);
    const { showSnackbar } = useSnackbar();
    const [getFormData, setFormData] = useState({
        sector: [],
        subSector: []
    });
    
    const handleReturnComponent = () => {
        handleChangeComponent('Consultar Sub Setores','consult');
    }

    const handleChangeSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, sector: value }));
    }

    const handleChangeSubSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, subSector: value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        const formDataToSend = new FormData();
        formDataToSend.append('sector', JSON.stringify(getFormData.sector));
        formDataToSend.append('subSector', JSON.stringify(getFormData.subSector));

        try {
            await AxiosInstance.post('/sector/link-sectors', formDataToSend, { headers: { "Content-Type": "multipart/form-data" } });
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Criado com Sucesso',
                variant: 'success',
            });
            handleReturnComponent();
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error.message,
                variant: 'error',
            });
        }
    }

    const handleGetSector = useCallback( async () => {
        const result = await AxiosInstance.get('/sector/consult-macro-sectors');
        
        const transformedData = await result.data.rows.map(item => ({
            id: item.id,
            value: item.description
        }));
        
        setOptionsSector(transformedData);
    }, [])

    const handleGetSubSector = useCallback( async () => {
        const result = await AxiosInstance.get('/sector/consult-sub-sectors');
        
        const transformedData = await result.data.rows.map(item => ({
            id: item.id,
            value: item.description
        }));
        
        setOptionsSubSector(transformedData);
    }, [])

    useEffect( ()=>{
        handleGetSector();
        handleGetSubSector();
    }, [handleGetSector,handleGetSubSector])

    return(
        <Box m={1}>
            <form onSubmit={handleSubmit} method='POST'>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} xl={12}>
                        <SelectAutoComplete 
                            name='sector'
                            value={getFormData.sector}
                            options={getOptionsSector} 
                            label='Selecione o Setor'
                            onChange={(event, selectValues) => handleChangeSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} xl={12}>
                        <MultiSelectAutocomplete 
                            name='subSector'
                            value={getFormData.subSector}
                            options={getOptionsSubSector} 
                            label='Selecione os Sub-Setores'
                            onChange={(event, selectValues) => handleChangeSubSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            variant='contained' 
                            color="primary"
                            onClick={handleReturnComponent}
                            fullWidth
                        >
                            voltar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            type='submit'  // Adicionando o tipo submit ao botão
                            variant='contained' 
                            color="success"
                            fullWidth
                        >
                                Vincular
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default LinkSectorSubSectorRegistre;